// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function filterInt(value: any) {
    if (/^[-+]?(\d+)$/.test(value)) {
        return Number(value);
    }

    return 0;
}
